import { QA_CLEVERTAP_ID, PROD_CLEVERTAP_ID } from 'AccountsConstants/settings'
import ClevertapReact from 'clevertap-react'
import { isTripDetailsPage } from './Trips/TripDetails'
import { isAndroidApp, isIosApp, checkMobileDevice } from './validator'
import { readCookie } from './nav-http-cookie'

export const triggerClevertap = (eventName, eventData) => {
  try {
    if (
      isIosApp() &&
      window.webkit !== undefined &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.clevertap
    ) {
      window.webkit.messageHandlers.clevertap.postMessage({
        event: eventName,
        props: eventData,
        action: 'recordEventWithProps'
      })
    } else if (window && window.clevertap) {
      if (isAndroidApp()) {
        if (eventData) {
          window.clevertap.pushEvent(eventName, JSON.stringify(eventData))
        } else {
          window.clevertap.pushEvent(eventName)
        }
      } else if (eventData) {
        let finalData = { ...eventData }
        if (eventData.trip_ID) {
          finalData = {
            ...finalData,
            ...{ trip_ID: `id_${eventData.trip_ID}` }
          }
        }
        if (eventData.trip_id) {
          finalData = {
            ...finalData,
            ...{ trip_id: `id_${eventData.trip_id}` }
          }
        }
        ClevertapReact.event(eventName, finalData)
      } else {
        ClevertapReact.event(eventName)
      }
    } else {
      console.warn(
        'clevertap is not initialized / iOS has not registered an event'
      )
    }
  } catch (e) {
    console.error(`error in clevertap event publish ${eventName}`, e)
  }
}

export const getClevertapPlatform = () => {
  let platform = 'desktop'
  if (isAndroidApp() && !isIosApp() && checkMobileDevice()) {
    platform = 'android'
  } else if (isIosApp() && !isAndroidApp() && checkMobileDevice()) {
    platform = 'iOS'
  } else if (!isIosApp() && !isAndroidApp() && checkMobileDevice()) {
    platform = 'pwa'
  }
  return platform
}
export const getCommonClevertapParams = () => {
  const params = {}
  params.domain = window.location.hostname
  params.source_page = isTripDetailsPage() ? 'trip_details' : 'trip_list'
  params.timestamp = new Date().toString()
  params.platform = getClevertapPlatform()
  const userid = decodeURIComponent(readCookie('userid'))
  if (userid) {
    [params.email_id] = userid.split('|')
  } else {
    params.email_id = 'NA'
  }
  return params
}

export const initializeClevertap = () => {
  if (
    window.location.origin.indexOf('0.0.0.0') > -1 ||
    window.location.origin.indexOf('qa2') > -1
  ) {
    ClevertapReact.initialize(QA_CLEVERTAP_ID)
  } else {
    ClevertapReact.initialize(PROD_CLEVERTAP_ID)
  }
  ClevertapReact.profile({
    Site: {
      Name: 'cleartrip user',
      Email: 'user@cleartrip.com',
      Identity: '123123123',
      Phone: '+912345677890',
      Gender: 'M'
    }
  })
}

export const fireEvent = (eventName, clevertapData) => {
  return () => {
    triggerClevertap(eventName, clevertapData)
  }
}
export const fireClevertapEvent = (event_type, clevertapData) => {
  triggerClevertap('Account', {
    ...getCommonClevertapParams(),
    ...clevertapData,
    event_type
  })
}
export const sendClevertapUIActionEvent = ({
  actionName,
  actionType = 'BUTTON',
  page,
  ...additionalData
}) => {
  const fullPayload = {
    action_name: actionName,
    action_type: actionType,
    source: 'web',
    domain: window.location.host,
    source_page_name: 'Support',
    ...additionalData
    // dom_intl: ,
    // journey_type:
  }

  fireClevertapEvent('ACCOUNT_UI_ACTION', fullPayload)
}

/**
 * @description - This is a function which will is used to communicate with the mobile apps
 * @param {eventName} - string - this is the eventName that we want to publish
 */
export const appJSCallBack = eventName => {
  try {
    if (
      window.webkit !== undefined &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers[eventName]
    ) {
      window.webkit.messageHandlers[eventName].postMessage(eventName)
    }
    if (window.appInterface !== undefined) {
      window.appInterface.postMessage(eventName)
    }
  } catch (e) {
    console.error(`app js callback error for event => ${eventName}`, e)
  }
}

export const fireClevertapPageLoad = payload => {
  const fullPayLoad = {
    ...payload,
    ...getCommonClevertapParams()
  }
  triggerClevertap('Air_PSPB_PageLoad', fullPayLoad)
}

export const fireClevertapUIAction = payload => {
  const fullPayLoad = {
    ...payload,
    ...getCommonClevertapParams()
  }
  triggerClevertap('Air_PSPB_UI_Action', fullPayLoad)
}
